import { LoadingButton } from "@mui/lab";
import { alpha } from "@mui/material";
import { CSSProperties, useContext, useEffect, useState } from "react";
import useLocales from "src/hooks/useLocales";
import useGetConnectExitCallback from "src/pages/Link/Products/ConnectAccount/ConnectStep/hook/useGetConnectExitCallback";
import palette from "src/theme/palette";

import ThemeContext from "../../context";

// ----------------------------------------------------------------------

type Props = {
	loading?: boolean;
	userConfirmationNeeded?: boolean;
};

export const CustomConnectBtn = ({ loading, userConfirmationNeeded }: Props) => {
	const [isDisabled, setIsDisabled] = useState(false);
	const { customConnectProps, entity } = useContext(ThemeContext);

	const { theme, themeType, updateToken, restoreToken } = customConnectProps!;

	const { translate } = useLocales();
	const { onExit } = useGetConnectExitCallback();

	const disabled =
		themeType === "DARK"
			? palette.dark.action.disabledBackground
			: palette.light.action.disabledBackground;

	const buttonStyle: CSSProperties = {
		borderRadius: theme?.button.shape,
		backgroundColor: loading || isDisabled ? disabled : theme?.colors.buttonBackground,
		color: loading || isDisabled ? disabled : theme?.colors.buttonText,
		fontWeight: theme?.button.textWeight === "BOLD" ? 700 : 500,
		fontSize: loading || isDisabled ? 0 : 14,
		width: theme?.button.width,
		boxShadow: `0 8px 16px 0 ${alpha(theme?.colors.buttonBackground ?? "#000", 0.24)}`
	};

	let label = "connect";

	useEffect(() => {
		if (userConfirmationNeeded) {
			setIsDisabled(true);
			setTimeout(() => {
				setIsDisabled(false);
			}, 5000);
		}
	}, [userConfirmationNeeded]);

	if (entity?.maintenance)
		return (
			<LoadingButton
				size='large'
				style={buttonStyle}
				onClick={() => onExit("MAINTENANCE")}
				sx={{ mt: 5, width: "100%", alignSelf: "center" }}
			>
				{translate(`Salir`)}
			</LoadingButton>
		);

	if (userConfirmationNeeded) label = "continue";
	if (updateToken) label = "continue";
	if (restoreToken) label = "restore";

	return (
		<LoadingButton
			variant='contained'
			size='large'
			type='submit'
			style={buttonStyle}
			sx={{ mt: 5, width: "100%", alignSelf: "center" }}
			loading={loading}
			disabled={isDisabled}
		>
			{translate(`connect_panel.${label}`)}
		</LoadingButton>
	);
};

export default CustomConnectBtn;
